import { graphql } from '@api/generated';

export const serviceQueueFieldsFragment = graphql(`
  fragment ServiceQueueFields on Queue {
    id
    entrypoints
    name
    memberIds
    routingStrategy
    sessions {
      id
      name
      position
      enteredAt
    }
    inboundRecording
    recoveryTime
    agentTimeout
    rolloverSettings {
      timeout
    }
  }
`);

export const serviceQueueStatsFragment = graphql(`
  fragment ServiceQueueStats on Queue {
    status {
      abandonedSessions
      activeSessionCount
      averageWait
      longestWait
      missedSessions
      recipientCount
      totalSessions
      activeRecipientCount
      availableRecipientCount
      estimatedWait
    }
  }
`);
